/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("market.title")}
      </Typography>
      <hr />

      {/* Sobre / About */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.about.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.about.body")}
        </Box>
      </Typography>

      {/* Energia Transacionada */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.transacted_energy.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.transacted_energy.body")}
        </Box>
      </Typography>

      {/* Preço Médio */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.average_price.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.average_price.body")}
        </Box>
      </Typography>

      {/* Evolução Preço Médio (vs OMIE) */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.avg_price_evolution.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.avg_price_evolution.body")}
        </Box>
      </Typography>

      {/* Transações por Membros */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.by_member.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.by_member.body")}
        </Box>
      </Typography>

      {/* Transações por Membro-Recurso */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.by_member_resource.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.by_member_resource.body")}
        </Box>
      </Typography>

      {/* Custo por Recurso */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.cost_by_resource.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.cost_by_resource.body")}
        </Box>
      </Typography>

      {/* Proveito por Recurso */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("market.analytics.sections.revenue_by_resource.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("market.analytics.sections.revenue_by_resource.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
